module.exports = __webpack_public_path__ + "sk-rv-life-mockup@2x.3rhwUpg_.png";